var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnologies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7V5h18v2H3zM1 7V5a2 2 0 012-2h18a2 2 0 012 2v15a2 2 0 01-2 2H3a2 2 0 01-2-2V7zm20 2v11H3V9h18zM9.715 11.281a.982.982 0 00-1.376 0L6.285 13.31a.952.952 0 00-.28.772c.016.223.11.44.282.61l2.052 2.026a.982.982 0 001.376 0 .953.953 0 000-1.359L8.339 14l1.376-1.36a.953.953 0 000-1.359zm5.946 0a.982.982 0 00-1.376 0 .953.953 0 000 1.36L15.661 14l-1.376 1.36a.953.953 0 000 1.358.982.982 0 001.376 0l2.052-2.026a.952.952 0 00.282-.61.952.952 0 00-.28-.772l-2.054-2.029z"
  })));
}
export default SvgTechnologies;